// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__24OpS","footer":"ReportModalFilter_footer__1W4xf"};